export default  {
    component: 'ups',
    name: 'ups',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Inverter Room',
            param: 'inverter_room',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, room id should start from **"1"**`
          },
          {
            name: 'Inverter ID',
            param: 'inverter_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block-room, inverter id should start from **"1"**`
          },
          {
            name: 'ZMU ID',
            param: 'zmu_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block-room-inverter, zmu id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `Concatination of all the device id's [1-1-1-1]`
          },
          {
            name: 'Name',
            param: 'name',
            type: 'text',
            description: `> For each block device name should be unique`
          },
          {
            name: 'ZMU Name',
            param: 'zmu_name',
            type: 'text',
            description: `> For each block device name should be unique`
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
            description: `- To add more than 1 tracker follow this json : {"voltage": false, "dc_power": {"count": 8, "nameMap": ["CT-1", "CT-2", "CT-3", "CT-4", "CT-5", "CT-6", "CT-10", "CT-11"], "multiple": true}, "dc_current": {"count": 8, "nameMap": ["CT-1", "CT-2", "CT-3", "CT-4", "CT-5", "CT-6", "CT-10", "CT-11"], "multiple": true, "stringCount": [55, 60, 55, 60, 55, 50, 45, 55]}, "temperature": false, "computed_dc_current": {"multiplying_factor": [3, 3, 1.5, 4, 12, 2, 12, 1]}}
            - To add multiplication factor for computed follow this json : {"Sheet1": {"multiplying_factor": [1.3423269237222724, 1.0081661457808246, 1.007455168245013, 1.0067451927917044, 1.0059350165979277, 1.0047221943132725, 1, 1, 1.0052271813429834, 1.0045203415369162, 1.0054293183189222, 1.0062386798148522, 1.006947940791461, 1.0076582023377672, 1, 1]}, "voltage": true, "dc_power": {"count": 15, "nameMap": ["CT-1", "CT-2", "CT-3", "CT-4", "CT-5", "CT-6", "CT-10", "CT-11", "CT-12", "CT-13", "CT-14", "CT-15", "CT-7", "CT-8", "CT-16"], "chStatus": {"13": "not_connected", "14": "not_connected", "15": "not_connected"}, "multiple": true}, "dc_current": {"count": 15, "nameMap": ["CT-1", "CT-2", "CT-3", "CT-4", "CT-5", "CT-6", "CT-10", "CT-11", "CT-12", "CT-13", "CT-14", "CT-15", "CT-7", "CT-8", "CT-16"], "chStatus": {"13": "not_connected", "14": "not_connected", "15": "not_connected"}, "multiple": true, "stringCount": [45, 60, 60, 60, 60, 60, null, null, 60, 60, 60, 60, 60, 60, null]}, "temperature": false, "computed_dc_power": {"count": 15, "nameMap": ["Computed CT-1", "Computed CT-2", "Computed CT-3", "Computed CT-4", "Computed CT-5", "Computed CT-6", "Computed CT-10", "Computed CT-11", "Computed CT-12", "Computed CT-13", "Computed CT-14", "Computed CT-15", "Computed CT-7", "Computed CT-8", "Computed CT-16"], "multiple": true, "multiplying_factor": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}, "computed_dc_current": {"count": 15, "nameMap": ["Computed CT-1", "Computed CT-2", "Computed CT-3", "Computed CT-4", "Computed CT-5", "Computed CT-6", "Computed CT-10", "Computed CT-11", "Computed CT-12", "Computed CT-13", "Computed CT-14", "Computed CT-15", "Computed CT-7", "Computed CT-8", "Computed CT-16"], "multiple": true, "multiplying_factor": [1.3423269237222724, 1.0081661457808246, 1.007455168245013, 1.0067451927917044, 1.0059350165979277, 1.0047221943132725, 1.0052271813429834, 1.0045203415369162, 1.0054293183189222, 1.0062386798148522, 1.006947940791461, 1.0076582023377672, 0, 0, 0]}} `
          },
          {
            name: 'Filter Config',
            param: 'filter_config',
            type: 'json',
            description: `Add threshold value for junk cleaner e.g. [{"validationRules": {"dc_current": {"type": "comma-separated", "maxValue": 150, "minValue": 0}}}]`
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-temperature)`
          },
          {
            name: 'Model',
            param: 'model',
            type: 'text',
          },
          {
            name: 'Reading Frequency',
            param: 'reading_frequency',
            type: 'text',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of blockname-roomname-devicename`
          },
    ]
  }

